<template>
  <div>
    <div>
      <el-form ref="hangForm" :model="hangObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.handOverAt')"
              :prop="'handOverAt'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.handOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="hangObj.handOverAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('text.remark')">
              <el-input size="small" v-model="hangObj.remark" />
            </el-form-item>
          </el-col>
        </el-row>
        <vxe-table
          :data="hangOrders"
          class="recordsTable"
          size="mini"
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="85"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images"></thumbnail>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="serialNo"
            :title="$t('order.serialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <small v-if="row.hurry" class="red">
                ({{ $t("order.hurrySimple") }})
              </small>
              <div>
                <s v-if="row.retrieveAt != null">{{ row.serialNo }}</s>
                <s
                  v-if="row.retrieveAt == null && row.jyOrderCancelAt != null"
                  class="grey"
                >
                  {{ row.serialNo }}
                </s>
                <span
                  v-if="row.retrieveAt == null && row.jyOrderCancelAt == null"
                >
                  {{ row.serialNo }}
                </span>
              </div>
              <state-label :state="row.workflowState">
                {{ $t("mesOrderStates." + row.workflowState) }}
              </state-label>
              <small v-if="row.pauseAt != null" class="orange">
                {{ $t("text.stop") }}
              </small>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="factoryName"
            :title="$t('menu.factories')"
            min-width="80"
          />
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <span
                v-if="
                  row.customerProductNo != null &&
                  row.customerProductNo.trim() != ''
                "
                class="font10"
                >({{ row.customerProductNo }})</span
              >
              <div class="font10">
                {{ row.categoryName }}
                <span v-if="row.productBrand != null">/</span>
                {{ row.productBrand }}
              </div>
              <div class="font10">{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            width="60"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}{{ row.unit }}
              <div>
                <el-popover
                  placement="right"
                  width="240"
                  trigger="click"
                  @show="showUnDealHangQtyInfo(row)"
                >
                  <vxe-table
                    :data="unDealHangs"
                    class="recordsTable"
                    size="mini"
                    highlight-hover-row
                    :scroll-y="{ enabled: false }"
                  >
                    <vxe-table-column
                      field="serialNo"
                      :title="$t('order.serialNo')"
                      min-width="160"
                    />
                    <vxe-table-column
                      field="quantity"
                      :title="$t('text.quantity')"
                      width="60"
                    >
                      <template v-slot="{ row }">
                        {{ row.quantity }}{{ row.unit }}
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                  <small slot="reference" class="mgb5 popover-reference">
                    挂单待处理:{{ row.unDealHangQty || 0 }}
                  </small>
                </el-popover>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="handOverAt"
            :title="$t('text.handOverAt')"
            width="110"
          ></vxe-table-column>
          <vxe-table-column
            field="remark"
            :title="$t('text.remark')"
            width="60"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number
                :content="row.remark"
                :number="15"
                type="richText"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row }">
              <el-button
                v-if="!(row.quantity - row.unDealHangQty < order.quantity)"
                type="text"
                :loading="submitDoing"
                size="small"
                @click="submit(row)"
                >{{ $t("action.hang") }}</el-button
              >
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
    </div>
    <div class="right pd20">
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Order from "@/api/order.js";
import OrderMes from "@/api/orderMes.js";

export default {
  props: {
    order: Object,
  },
  mixins: [page],
  components: { Thumbnail, RawHtmlLimitNumber },
  data() {
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      hangObj: {
        handOverAt: null,
        remark: null,
        hangSerialNo: null,
        hangUuid: null,
        factoryId: null,
        factoryName: null,
      },
      hangOrders: [],
      unDealHangs: [],
      submitDoing: false,
    };
  },
  watch: {
    order() {
      this.getHangOrders();
    },
  },
  created() {
    const self = this;
    self.getHangOrders();
  },

  methods: {
    getHangOrders() {
      const self = this;
      self.hangObj.remark = null;
      self.hangObj.handOverAt = self.order.handOverAt;
      const data = {
        productNo: self.order.productNo,
        size: self.order.size,
        color: self.order.color,
        quantity: self.order.quantity,
      };
      OrderMes.findSameSpecReplenishs(data).then(function (res) {
        if (res.status === 200) {
          self.hangOrders = res.data;
        } else {
          self.sysError();
        }
      });
    },
    showUnDealHangQtyInfo(row) {
      const self = this;
      OrderMes.unDealHangOrdersByUuid(row.uuid).then(function (res) {
        if (res.status === 200) {
          self.unDealHangs = res.data;
        } else {
          self.sysError();
        }
      });
    },
    submit(row) {
      const self = this;
      this.$refs.hangForm.validate((valid) => {
        if (valid) {
          self.hangObj.handOverAt =
            Util.formatDate(self.hangObj.handOverAt) + " 00:00:00";
          self.hangObj.hangSerialNo = row.serialNo;
          self.hangObj.hangUuid = row.uuid;
          self.hangObj.factoryId = row.factoryId;
          self.hangObj.factoryName = row.factoryName;
          self.submitDoing = true;
          Order.hang(self.order.id, self.hangObj).then(function (res) {
            self.submitDoing = false;
            self.remakeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.hangSuccess"),
                type: "success",
              });
              self.$emit("updateData");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
